module.exports = __webpack_public_path__ + "static/media/prep-interior.64d9ac86.png";